export function formatMoney(amount, decimals = 2) {
  if (amount === null || amount === undefined) return '0.00'
  return Number(amount).toFixed(decimals)
}

export function formatMoneyWithSymbol(amount, symbol = '') {
  return `${symbol}${formatMoney(amount)}`
}

export function formatPercent(value) {
  if (value === null || value === undefined) return '0%'
  return `${(Number(value) * 100).toFixed(2)}%`
}

export function addMoney(a, b) {
  return Number(a) + Number(b)
}

export function subtractMoney(a, b) {
  return Number(a) - Number(b)
}

export function multiplyMoney(a, b) {
  return Number(a) * Number(b)
}

export function divideMoney(a, b) {
  if (Number(b) === 0) return 0
  return Number(a) / Number(b)
}

export function centToYuan(cent) {
  if (cent === null || cent === undefined) return '0.00'
  return (Number(cent) / 100).toFixed(2)
}

export function centToYuanTrim(cent) {
  if (cent === null || cent === undefined) return '0'
  return String(parseFloat((Number(cent) / 100).toFixed(2)))
}